import React from "react";
import {
  AlignCenter,
  AlignJustify,
  AlignLeft,
  AlignRight,
  BarChart3,
  ArrowLeft,
  ArrowRight,
  AppWindow,
  Ban,
  BellRing,
  Bot,
  Brain,
  Briefcase,
  Building,
  Building2,
  Calendar,
  CalendarCheck,
  CheckCircle2,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  Circle as CircleBase,
  CircleAlert,
  CircleDot,
  CircleX,
  Clock,
  Code2,
  ConciergeBell,
  ExternalLink,
  Copy,
  Contrast as ContrastIcon,
  Cpu,
  DollarSign,
  DoorOpen,
  Flag as FlagIcon,
  FileText,
  FileWarning,
  Gauge,
  Gavel as GavelIcon,
  GitBranch,
  GraduationCap,
  Headphones,
  History as HistoryIcon,
  Info as InfoIcon,
  Keyboard as KeyboardIcon,
  LayoutDashboard,
  Link as LinkIconBase,
  Lightbulb as LightbulbIcon,
  List as ListBase,
  LayoutGrid,
  Maximize,
  MessageCircle,
  Mic as MicIcon,
  MicOff as MicOffIcon,
  Minimize2,
  Monitor as MonitorIcon,
  MonitorSmartphone,
  MonitorUp,
  Moon,
  Network,
  Package,
  Palette,
  Pencil,
  Pin,
  Plane,
  Play,
  Plus,
  ShoppingBag as ShoppingBagBase,
  ReceiptText,
  RefreshCw,
  Reply as ReplyIcon,
  RotateCcw,
  Save,
  Search as SearchIcon,
  Send as SendIcon,
  Settings as SettingsIcon,
  ShieldCheck,
  ShoppingCart as ShoppingCartIcon,
  Sparkles,
  Store as StoreIcon,
  Sun,
  Tags,
  Timer as TimerIcon,
  Trash2,
  TriangleAlert,
  TrendingUp as TrendingUpIcon,
  Trophy,
  Type,
  User,
  Users,
  Camera,
  Check as CheckIcon,
  Eye,
  Lock as LockIcon,
  Video,
  VideoOff,
  Volume2,
  VolumeX,
  Wifi as WifiIcon,
  X,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
} from "lucide-react";
import { sxToStyle } from "./LayoutPrimitives";

const sizeByFontSize = {
  inherit: "1em",
  large: 28,
  medium: 24,
  small: 18,
};

const createIcon = (Icon) => {
  const WrappedIcon = ({ fontSize, sx, style, ...props }) => (
    <Icon
      aria-hidden={props["aria-label"] ? undefined : true}
      size={sizeByFontSize[fontSize] || fontSize || props.size || 20}
      style={{ ...sxToStyle(sx), ...(style || {}) }}
      {...props}
    />
  );
  WrappedIcon.displayName = Icon.displayName || Icon.name || "Icon";
  return WrappedIcon;
};

export const Close = createIcon(X);
export const Send = createIcon(SendIcon);
export const Person = createIcon(User);
export const ArrowBack = createIcon(ArrowLeft);
export const ArrowForward = createIcon(ArrowRight);
export const Psychology = createIcon(Brain);
export const SmartToy = createIcon(Bot);
export const ExpandLess = createIcon(ChevronUp);
export const ExpandMore = createIcon(ChevronDown);
export const OpenInNew = createIcon(ExternalLink);
export const Minimize = createIcon(Minimize2);
export const AutoAwesome = createIcon(Sparkles);
export const Lightbulb = createIcon(LightbulbIcon);
export const SupportAgent = createIcon(Headphones);
export const School = createIcon(GraduationCap);
export const Work = createIcon(Briefcase);
export const Chat = createIcon(MessageCircle);
export const History = createIcon(HistoryIcon);
export const Delete = createIcon(Trash2);
export const ContentCopy = createIcon(Copy);
export const Business = createIcon(Building2);
export const Description = createIcon(FileText);
export const People = createIcon(Users);
export const TrendingUp = createIcon(TrendingUpIcon);
export const Assessment = createIcon(BarChart3);
export const CalendarToday = createIcon(Calendar);
export const AttachMoney = createIcon(DollarSign);
export const Security = createIcon(ShieldCheck);
export const Speed = createIcon(Gauge);
export const Dashboard = createIcon(LayoutDashboard);
export const Inventory = createIcon(Package);
export const ShoppingCart = createIcon(ShoppingCartIcon);
export const Store = createIcon(StoreIcon);
export const Category = createIcon(Tags);
export const Domain = createIcon(Network);
export const AccountTree = createIcon(GitBranch);
export const Analytics = createIcon(BarChart3);
export const Report = createIcon(FileWarning);
export const Settings = createIcon(SettingsIcon);
export const BusinessCenter = createIcon(Briefcase);
export const CorporateFare = createIcon(Building);
export const DesignServices = createIcon(Palette);
export const TravelExplore = createIcon(Plane);
export const Code = createIcon(Code2);
export const Computer = createIcon(MonitorIcon);
export const List = createIcon(ListBase);
export const ListIcon = createIcon(ListBase);
export const Receipt = createIcon(ReceiptText);
export const Schedule = createIcon(Clock);
export const Event = createIcon(Calendar);
export const EventAvailable = createIcon(CalendarCheck);
export const MeetingRoom = createIcon(DoorOpen);
export const CheckCircle = createIcon(CheckCircle2);
export const CheckCircleOutline = createIcon(CheckCircle2);
export const CheckCircleOutlineIcon = createIcon(CheckCircle2);
export const Search = createIcon(SearchIcon);
export const PlayArrow = createIcon(Play);
export const PlayCircleOutline = createIcon(Play);
export const Visibility = createIcon(Eye);
export const Refresh = createIcon(RefreshCw);
export const Lock = createIcon(LockIcon);
export const Assignment = createIcon(FileText);
export const Article = createIcon(FileText);
export const FileIcon = createIcon(FileText);
export const LinkIcon = createIcon(LinkIconBase);
export const QuizIcon = createIcon(Brain);
export const EmojiEvents = createIcon(Trophy);
export const ErrorOutline = createIcon(CircleAlert);
export const Info = createIcon(InfoIcon);
export const ArrowRightAltRounded = createIcon(ArrowRight);
export const CalendarMonth = createIcon(Calendar);
export const AccessTime = createIcon(Clock);
export const MenuBook = createIcon(FileText);
export const Class = createIcon(GraduationCap);
export const ShoppingBag = createIcon(ShoppingBagBase);
export const AddRounded = createIcon(Plus);
export const ForumOutlined = createIcon(MessageCircle);
export const KeyboardArrowRightRounded = createIcon(ChevronRight);
export const LockOutlined = createIcon(LockIcon);
export const PeopleAltOutlined = createIcon(Users);
export const PushPinRounded = createIcon(Pin);
export const QuestionAnswerOutlined = createIcon(MessageCircle);
export const RemoveRedEyeOutlined = createIcon(Eye);
export const ReplyRounded = createIcon(ReplyIcon);
export const SearchRounded = createIcon(SearchIcon);
export const SendRounded = createIcon(SendIcon);
export const EditRounded = createIcon(Pencil);
export const SaveRounded = createIcon(Save);
export const CloseRounded = createIcon(X);
export const Videocam = createIcon(Video);
export const Mic = createIcon(MicIcon);
export const Monitor = createIcon(MonitorIcon);
export const Warning = createIcon(TriangleAlert);
export const Error = createIcon(CircleX);
export const Fullscreen = createIcon(Maximize);
export const FullscreenExit = createIcon(Minimize2);
export const FormatSize = createIcon(Type);
export const TextFields = createIcon(Type);
export const Contrast = createIcon(ContrastIcon);
export const Nightlight = createIcon(Moon);
export const WbSunny = createIcon(Sun);
export const ZoomIn = createIcon(ZoomInIcon);
export const ZoomOut = createIcon(ZoomOutIcon);
export const ResetTv = createIcon(RotateCcw);
export const FormatAlignLeft = createIcon(AlignLeft);
export const FormatAlignCenter = createIcon(AlignCenter);
export const FormatAlignRight = createIcon(AlignRight);
export const FormatAlignJustify = createIcon(AlignJustify);
export const LineWeight = createIcon(ListBase);
export const Workspaces = createIcon(LayoutGrid);
export const RoomService = createIcon(ConciergeBell);
export const GroupWork = createIcon(Network);
export const KeyboardArrowUp = createIcon(ChevronUp);
export const Tab = createIcon(LayoutDashboard);
export const WebAsset = createIcon(AppWindow);
export const Block = createIcon(Ban);
export const VerifiedUser = createIcon(ShieldCheck);
export const HeadsetMic = createIcon(Headphones);
export const ScreenshotMonitor = createIcon(MonitorUp);
export const Timer = createIcon(TimerIcon);
export const NotificationsActive = createIcon(BellRing);
export const Keyboard = createIcon(KeyboardIcon);
export const Memory = createIcon(Cpu);
export const Wifi = createIcon(WifiIcon);
export const Devices = createIcon(MonitorSmartphone);
export const VolumeUp = createIcon(Volume2);
export const VolumeOff = createIcon(VolumeX);
export const CameraAlt = createIcon(Camera);
export const Replay = createIcon(RotateCcw);
export const Check = createIcon(CheckIcon);
export const Circle = createIcon(CircleBase);
export const RadioButtonUnchecked = createIcon(CircleBase);
export const FiberManualRecord = createIcon(CircleDot);
export const VideocamOff = createIcon(VideoOff);
export const Gavel = createIcon(GavelIcon);
export const Flag = createIcon(FlagIcon);
export const MicOff = createIcon(MicOffIcon);
